import React from 'react';
import ToggleSwitch from './ToggleSwitch';

function ToggleSwitchContainer(properties) {
  return <ToggleSwitch {...properties} />;
}

export default ToggleSwitchContainer;
